module.exports = __webpack_public_path__ + "assets/img/maestro@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/maestro@2x.png
// module id = 135
// module chunks = 0